import { useEffect, useState } from "react";
import { getDateFirstDay4 } from "../../utils/getDate";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UserRequestCard = ({ requestData }) => {
    const {t, i18n} = useTranslation();
    const [italianStatus, setItalianStatus] = useState(null);
    useEffect(() => {
        if (requestData.status) {
            switch (requestData.status) {
                case 'picked':
                    setItalianStatus(t("ProfilePage.userRequestCard.statusLabel.picked"))
                    break;
                case 'accepted':
                    setItalianStatus(t("ProfilePage.userRequestCard.statusLabel.accepted"))
                    break;
                case 'declined':
                    setItalianStatus(t("ProfilePage.userRequestCard.statusLabel.declined"))
                    break;
                case 'purchased':
                    setItalianStatus(t("ProfilePage.userRequestCard.statusLabel.purchased"))
                    break;
                default:
                    break;
            }
        }
    }, [requestData, i18n.language])
    return (
        <div className="w-full p-2 rounded-xl border border-[#225424] flex flex-col md:justify-center gap-4 md:flex-row md:gap-8">
            {/* Id richiesta */}
            <div className="border-b-2 md:border-r-2 md:pr-2">
                <h5 className="md:text-end text-xs">{t("ProfilePage.userRequestCard.requestId")}:</h5>
                <div className="font-bold text-[#225424]">{requestData?.requestId}</div>
            </div>
            {/* Nome attività */}
            <div className="border-b-2 md:border-r-2 md:pr-2">
                <h5 className="md:text-end text-xs">{t("ProfilePage.userRequestCard.activityTitle")}:</h5>
                <Link to={`/activity-details?id=${requestData?.activityId}`}><div className="font-bold underline">{requestData?.title}</div></Link>
            </div>
            {/* Data richiesta */}
            <div className="border-b-2 md:border-r-2 md:pr-2">
                <h5 className="md:text-end text-xs">{t("ProfilePage.userRequestCard.requestDate")}:</h5>
                <div className="font-bold">{getDateFirstDay4(requestData?.requestDate)}</div>
            </div>
            {/* Stato */}
            <div>
                <h5 className="text-xs">{t("ProfilePage.userRequestCard.requestStatus")}:</h5>
                <div className={`font-bold${requestData?.status === 'picked' && 'text-[#225424]'} ${requestData?.status === 'accepted' && 'text-yellow-500'} ${requestData?.status === 'declined' && 'text-red-500'} ${requestData?.status === 'purchased' && 'text-green-500'}`}>{italianStatus}</div>
            </div>
            {/* Data ultimo aggiornamento stato */}
        </div>
    )
}

export default UserRequestCard